<template>
  <div>
    <el-form ref="formRef" label-width="90px">
      <el-form-item label="旧手机号：">
        <el-input type="input" v-model="oldPhone" size="medium" style="width:25em;" placeholder="请输入原来手机号"></el-input>
      </el-form-item>
      <el-form-item label="新手机号：">
        <el-input type="input" v-model="newPhone" size="medium" style="width:25em;" placeholder="请输入新的手机号"></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import {postFormData, postJson} from "@/api/api"
import { changeUserPhone } from "@/api/url";
import {phoneReg } from "@/assets/shared/reg-constant";

export default {
name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
   return {
     oldPhone: '',
     newPhone: '',
   }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!phoneReg.test(this.oldPhone)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '旧手机号码格式不正确',
          type: 'warning'
        });
        return false
      }
      if(!phoneReg.test(this.newPhone)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '新手机号码格式不正确',
          type: 'warning'
        });
        return false
      }
      let param = {}
      param['oldPhone'] = this.oldPhone;
      param['newPhone'] = this.newPhone;
      postFormData(changeUserPhone, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

  }
}
</script>

<style scoped>

</style>
